export default __webpack_public_path__ + "static/media/headphones-3 1.eb039b88.svg";